import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Detailing from "./sections/Detailing";
import Convenience from "./sections/Convenience";
import Services from "./sections/Services";
import Reflections from "./sections/Reflections";
import ServiceArea from "./sections/ServiceArea";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Detailing />
      
      <Services />
      <Reflections />
      <ServiceArea />
      <Footer />
    </div>;
}